import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import syncReducer from './slices/syncSlice'
import { jobsReducer } from './slices/jobsSlice'
import { nodesReducer } from './slices/nodesSlice'
import { photosReducer } from './slices/photosSlice'
import { reportsReducer } from './slices/reportsSlice'
import { notificationsReducer } from './slices/notificationsSlice'
import { arboristProfileReducer } from './slices/arboristProfileSlice'

/**
 * Redux store configuration
 * - Configured with Redux Toolkit
 * - Includes all feature slices
 * - DevTools enabled in development
 */
export const store = configureStore({
  reducer: {
    auth: authReducer,
    sync: syncReducer,
    jobs: jobsReducer,
    nodes: nodesReducer,
    photos: photosReducer,
    reports: reportsReducer,
    notifications: notificationsReducer,
    arboristProfile: arboristProfileReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for Supabase Session objects
        ignoredActions: [
          'auth/setSession',
          'auth/login/fulfilled',
          'auth/register/fulfilled',
          'auth/checkSession/fulfilled',
        ],
        // Ignore these paths in the state
        ignoredPaths: ['auth.session', 'auth.user'],
      },
    }),
  devTools: import.meta.env.DEV,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
